"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._utils = void 0;
/**
 * helper functions
 *
 */
class Utils {
    // remove null, '' and undefined properties from a literal.
    literal(literal) {
        if (!literal) {
            return undefined;
        }
        Object.keys(literal).forEach(key => !literal[key] && delete literal[key]);
        return literal;
    }
    ;
}
exports._utils = new Utils();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJpdmF0ZS91dGlscy91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7O0dBR0c7QUFDSCxNQUFNLEtBQUs7SUFDVCwyREFBMkQ7SUFDM0QsT0FBTyxDQUFFLE9BQU87UUFDZCxJQUFJLENBQUMsT0FBTyxFQUFFO1lBQ1osT0FBTyxTQUFTLENBQUM7U0FDbEI7UUFDRCxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLE9BQU8sT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7UUFDMUUsT0FBTyxPQUFPLENBQUM7SUFDakIsQ0FBQztJQUFBLENBQUM7Q0FDSDtBQUVZLFFBQUEsTUFBTSxHQUFHLElBQUksS0FBSyxFQUFFLENBQUMifQ==